import { unwrapMarketplaceBody } from "../api/marketplaceResponse";
import useMyApiClient from "./useMyApiClient";

function unwrapResponseData(data, endpointForBypass) {
  return unwrapMarketplaceBody(data, { endpoint: endpointForBypass });
}

/** Query keys repeated as `key=v1&key=v2` (Spring-style), not `key[]=v1`. */
const REPEATED_QUERY_PARAM_KEYS = new Set(["class"]);

/**
 * Custom params serializer for axios that handles arrays as multiple query params
 * @param {Object} params - Parameters object
 * @returns {string} Serialized query string
 */
export function paramsSerializer(params) {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) {
      continue;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== null && item !== undefined) {
          const paramKey = REPEATED_QUERY_PARAM_KEYS.has(key) ? key : `${key}[]`;
          searchParams.append(paramKey, String(item));
        }
      });
    } else {
      searchParams.append(key, String(value));
    }
  }

  return searchParams.toString();
}

function useMyService() {
  const myApiClient = useMyApiClient();

  function getAllEntities({ params, page = 0, size = 100, endpoint, signal }) {
    const allParams = { page, size, ...params };
    return myApiClient
      .get(endpoint, {
        params: allParams,
        paramsSerializer,
        signal,
      })
      .then((response) => unwrapResponseData(response.data, endpoint));
  }

  function getEntityById({ id, params, endpoint, signal }) {
    const endpointNew = `${endpoint}/${id}`;

    return myApiClient
      .get(endpointNew, {
        params,
        signal,
      })
      .then((response) => unwrapResponseData(response.data, endpointNew));
  }

  const addEntity = ({ dataObj, endpoint, signal }) => {
    return myApiClient
      .post(endpoint, dataObj, { signal })
      .then((response) => unwrapResponseData(response.data, endpoint));
  };

  const updateEntity = async ({ dataObj, endpoint, signal }) => {
    const endpointNew = `${endpoint}/${dataObj.id}`;

    return myApiClient
      .put(endpointNew, dataObj, { signal })
      .then((response) => unwrapResponseData(response.data, endpointNew));
  };

  const deleteEntity = async ({ id, endpoint, signal }) => {
    const endpointNew = `${endpoint}/${id}`;

    return myApiClient
      .delete(endpointNew, { signal })
      .then((response) => unwrapResponseData(response.data, endpointNew));
  };

  return {
    getAllEntities,
    getEntityById,
    addEntity,
    updateEntity,
    deleteEntity,
  };
}
export default useMyService;
